import { BG_STAGE, classImplementsInterfaces, currentBrowserInfo, TUTORIAL_STAGE, UI_STAGE, STATIC_STAGE } from "@goodgamestudios/createjs-utilities";

import { BasicDialogHandler, EnvGlobalsHandler, NoneValueSignal, BasicProperties, BasicScreen } from "@goodgamestudios/core";
import { IEnvironmentGlobals } from "@goodgamestudios/core";
import { BasicBackgroundComponent } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { BasicDialog } from "@goodgamestudios/core";
import { FlashUIComponent } from "@goodgamestudios/core";
import { BasicLayoutManager } from "@goodgamestudios/core";
import { BasicPanel } from "@goodgamestudios/core";
import { BrowserUtil } from "@goodgamestudios/core";
import { StageDisplayState } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";

import { BasicDialogProperties } from "../../basic/view/dialogs/BasicDialogProperties";

import { Poker2DialogEvent } from "../event/Poker2DialogEvent";
import { Poker2Model } from "../model/Poker2Model";
import { Poker2Panel } from "./panels/Poker2Panel";

import DisplayObject = createjs.DisplayObject;
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import Event = createjs.Event;

export class Poker2LayoutManager extends BasicLayoutManager {
    public tutPanel: Poker2TutorialPanel;
    private _previousState: number = 0;
    private _animationLayer: Container;
    public tooltipManager: Poker2ToolTipManager;

    public backgroundScreen: Poker2BackgroundScreen;
    public staticBackgroundLayer: Container;
    /**
     * contains animation for uistage, will be placed in static stage, so that uistage can be drawn in lower frequency
     */
    public uiAnimationLayer: Container;
    private _metaPanelLayer: Container;
    protected metaPanels: Map<string, BasicPanel> = new Map();

    public static GAME_SCALE_FACTOR: number = 2; // this is the scale factor with which the assets are scaled up

    public static GAME_HEIGHT: number = 600;
    public static GAME_WIDTH: number = 800;

    // STATE 1-9 outgame, STATE 10+ ingame
    public static STATE_CONNECT: number = 1;
    public static STATE_LOGIN: number = 2;
    public static STATE_SOCIAL_LOGIN: number = 3;

    public static STATE_ONTABLE: number = 10;
    public static STATE_LOBBY: number = 11;
    public static STATE_SHOP: number = 12;
    public static STATE_INVENTORY: number = 13;
    public static STATE_TOURNAMENT_LOBBY: number = 14;
    public static STATE_TOURNAMENT_TABLES: number = 15;
    public static STATE_TUTORIAL: number = 16;
    public static STATE_SITNGO_LOBBY: number = 17;
    public static STATE_RANKING: number = 18;
    public static STATE_ACHIEVEMENT_STATS: number = 19;
    public static STATE_BOOSTER: number = 20;

    public static CANVAS_RESIZED_SIGNAL: NoneValueSignal;

    public uiStage: createjs.Stage;
    public bgStage: createjs.Stage;
    public staticStage: createjs.Stage;
    public gameStage: createjs.Stage;
    public tutorialStage: createjs.Stage;

    private languageSelectionAssets: Library.PokerLanguageSelection.PokerLanguageSelection;
    private renderBgStageOnNextTick = false;

    public onMenu = false;

    private constructor() {
        CONSTRUCTOR_HACK;
        super();
    }

    /**
     * In HTML5, we use a second canvas to render the interfaces
     * This improves the performance of mouse hittests a lot
     */
    private prepareUIStage(): void {
        this.uiStage = new createjs.Stage("PokerUI");
        //this.uiStage.enableMouseOver(PokerGame.STAGE_MOUSEOVER_TIME);
        this.uiStage.snapToPixelEnabled = true;
        window.addEventListener(Event.RESIZE, this.bindFunction(this.onWindowResized) as any, false);
        this.uiStage.nextStage = this.stage; // transfer all mouseevents from higher canvas to lower canvas
        this.stage.enableDOMEvents(false);   // therefore the lower canvas doesn't need to receive any events on it's own
        window.uiStage = this.uiStage;
        this.uiStage.name = UI_STAGE;
    }

    private _lastModelDataUpdateTime = 0;
    private onStaticStageEnterFrame(event: createjs.TickerEvent) {
        if((event as any).timeStamp - this._lastModelDataUpdateTime > 200) {
            Poker2Model.updateModelData();
            this._lastModelDataUpdateTime = (event as any).timeStamp;
        }
    }
    private prepareStaticStage(): void {
        this.staticStage = new createjs.Stage("PokerStatic");
        this.staticStage.snapToPixelEnabled = true;
        window.staticStage = this.staticStage;
        this.staticStage.name = STATIC_STAGE;
        this.staticStage.nextStage = this.uiStage;
        this.staticStage.addEventListener(Event.ENTER_FRAME, this.bindFunction(this.onStaticStageEnterFrame));
    }

    private prepareBGStage(): void {
        this.bgStage = new createjs.Stage("PokerBG");
        this.bgStage.snapToPixelEnabled = true;
        (window as any).bgStage = this.bgStage;
        this.bgStage.name = BG_STAGE;
        this.bgStage.tickEnabled = this.bgStage.tickChildren = this.bgStage.tickOnUpdate = false;
    }

    // call this only when starting the tutorial!
    public prepareTutorialStage(): void {
        this.tutorialStage = new createjs.Stage("PokerTutorial");
        this.tutorialStage.enableMouseOver(PokerGame.STAGE_MOUSEOVER_TIME);
        this.tutorialStage.snapToPixelEnabled = true;
        this.tutorialStage.nextStage = this.staticStage;
        this.uiStage.enableDOMEvents(false);
        (window as any).tutorialStage = this.tutorialStage;
        this.tutorialStage.name = TUTORIAL_STAGE;
    }

    private _uitageUpdateThrottle = 0;
    // ONLY call this from PokerGame!!
    public renderStages(tickObj: createjs.TickerEvent): void {
        if (!tickObj) {
            console.warn("Do not call this from other places than PokerGame!");
        }
        if(this.uiStage.tickEnabled) {
            if(this._uitageUpdateThrottle % (tickObj.delta > 25 ? (this.onMenu ? 1 : 5) : 1) == 0) {
                this.uiStage.update( tickObj );
                this._uitageUpdateThrottle = 1;
            } else {
                this._uitageUpdateThrottle++;
            }
        }
        if(this.staticStage.tickEnabled) {
            this.staticStage.update(tickObj);
        }
        if (this.bgStage && this.renderBgStageOnNextTick) {
            this.bgStage.update(tickObj);
            this.renderBgStageOnNextTick = false;
        }
    }

    public renderBGStage(): void {
        // renderStages will do the real rendering, so bg sync with others on low performance
        this.renderBgStageOnNextTick = true;
    }

    public renderTutorialStage(tickObj: createjs.TickerEvent): void {
        this.tutorialStage.update(tickObj);
    }

    private onWindowResized(ev: createjs.Event = null): void {
        let dpr:number = window.devicePixelRatio || 1;
        if (this.gameStage) {
            this.gameStage.canvas.width = window.innerWidth;
            this.gameStage.canvas.height = window.innerHeight;
            this.gameStage.setBounds(0, 0, window.innerWidth, window.innerHeight);
            this.gameStage.scaleX = this.gameStage.scaleY = dpr;
            this.fixCanvasSize(this.gameStage.canvas);
        }

        if (this.uiStage) {
            this.uiStage.canvas.width = window.innerWidth;
            this.uiStage.canvas.height = window.innerHeight;
            this.uiStage.setBounds(0, 0, window.innerWidth, window.innerHeight);
            this.uiStage.scaleX = this.uiStage.scaleY = dpr;
            this.fixCanvasSize(this.uiStage.canvas);
        }

        if (this.bgStage) {
            this.bgStage.canvas.width = window.innerWidth;
            this.bgStage.canvas.height = window.innerHeight;
            this.bgStage.setBounds(0, 0, window.innerWidth, window.innerHeight);
            this.bgStage.scaleX = this.bgStage.scaleY = dpr;
            this.fixCanvasSize(this.bgStage.canvas);
        }

        if (this.tutorialStage) {
            this.tutorialStage.canvas.width = window.innerWidth;
            this.tutorialStage.canvas.height = window.innerHeight;
            this.tutorialStage.setBounds(0, 0, window.innerWidth, window.innerHeight);
            this.tutorialStage.scaleX = this.tutorialStage.scaleY = dpr;
            this.fixCanvasSize(this.tutorialStage.canvas);
        }

        if (this.staticStage) {
            this.staticStage.canvas.width = window.innerWidth;
            this.staticStage.canvas.height = window.innerHeight;
            this.staticStage.setBounds(0, 0, window.innerWidth, window.innerHeight);
            this.staticStage.scaleX = this.staticStage.scaleY = dpr;
            this.fixCanvasSize(this.staticStage.canvas);
        }

        Poker2LayoutManager.CANVAS_RESIZED_SIGNAL.signal();
        this.renderBGStage();
        if(this.uiAnimationLayer.visible && this.uiAnimationLayer.children.length) {
            this.hidePanel("Poker2MenuPanel");
            this.showPanel("Poker2MenuPanel");
        }
    }

    private fixCanvasSize(canvas: HTMLCanvasElement) {
        let ctx = canvas.getContext('2d');
        let dpr:number = window.devicePixelRatio || 1;
        let width:number = window.innerWidth;
        let height:number = window.innerHeight;
        canvas.style.width = width + "px";
        canvas.style.height = height + "px";

        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(height * dpr);

        ctx.scale(dpr, dpr);
    }

    public static getInstance(): Poker2LayoutManager {
        return BasicLayoutManager.getInstance() as Poker2LayoutManager;
    }

    public initialize(background: BasicBackgroundComponent): void {
        super.initialize(background);
        // create background stage
        this.prepareBGStage();

        // create second stage
        this.prepareUIStage();
        this.prepareStaticStage();

        this.prepareTutorialStage();
        this.tooltipManager = new Poker2ToolTipManager(this.tooltipLayer);
        this._animationLayer = new Container();
        this._animationLayer.name = "animationLayer";

        if (!(!currentBrowserInfo.isIE && this.env.loginIsKeyBased))
            background.customCursor.showCustomCursor();
        else
            background.customCursor.hideCustomCursor();

        // add new layer for meta panels (e.g. for language selection)
        this._metaPanelLayer = new Container();
        this.staticBackgroundLayer = new Container();
        this.uiAnimationLayer = new Container();
        this.uiAnimationLayer.name = "uiAnimationLayer";

        this.addChild(this.screenLayer);
        this.screenLayer.name = "screenLayer";
        this.addChild(this.backgroundLayer);
        this.backgroundLayer.name = "backgroundLayer";
        this.uiStage.addChild(this.panelLayer);
        this.staticStage.addChild(this.uiAnimationLayer);
        this.staticStage.addChild(this._animationLayer);
        this.staticStage.addChild(this.dialogLayer);
        this.tutorialStage.addChild(this.tutorialLayer);
        this.uiStage.addChild(this._metaPanelLayer);
        this.staticStage.addChild(this.tooltipLayer);
        this.uiStage.addChild(this.adminLayer);
        this.uiStage.addChild(this.mouseLayer);
        this.bgStage.addChild(this.staticBackgroundLayer);

        // resize stages to window
        this.onWindowResized();

        this.languageSelectionAssets = new Library.PokerLanguageSelection.PokerLanguageSelection();
    }

    /**
     * show screen by NAME and added to screenLayer
     * set properties if given
     */
    public showScreen(screenId: any, properties: BasicProperties = null): BasicScreen {
        let screen = super.showScreen(screenId, properties);
        if (["Poker2BackgroundScreen"].indexOf(screenId) >= 0) {
            if (screen.disp.stage !== this.bgStage) {
                this.staticBackgroundLayer.addChild(screen.disp);
            }
        }
        return screen;
    }

    // since game stage will be paused, we move the logic to staticStage
    // protected onEnterFrame(event: Event): void {
    //     Poker2Model.updateModelData();
    //     super.onEnterFrame(event);
    // }

    private _state: number = 0;

    public set state(stateId: number) {
        this.uiAnimationLayer.visible = true;
        this._state = stateId;
        switch (stateId) {
            case Poker2LayoutManager.STATE_SOCIAL_LOGIN:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllScreens();
                this.backgroundLayer.visible = true;
                this.uiAnimationLayer.visible = false;
                this.showBackgroundLayer();
                this.renderBGStage();
                this.disableProgressbar();
                break;
            case 1:
                this.hideAllDialogs();
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllScreens();
                this.backgroundLayer.visible = true;  // contains the start screen animation
                this.uiAnimationLayer.visible = false;
                this.showBackgroundLayer();
                this.renderBGStage();
                break;
            case BasicLayoutManager.STATE_AVATAR_CREATION:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllScreens();
                this.backgroundLayer.visible = true;
                this.uiAnimationLayer.visible = false;
                this.showDialog("Poker2AvatarCreationDialog");
                this.showMetaPanel(this.languageSelectionAssets);
                break;
            case 2:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllScreens();
                this.backgroundLayer.visible = true;
                this.uiAnimationLayer.visible = false;
                this.showPanel("Poker2LoginPanel");
                this.showMetaPanel(this.languageSelectionAssets);
                break;
            case 11:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2FriendsPanel");
                this.showScreen("Poker2BackgroundScreen");
                this.showScreen("Poker2LobbyTablesScreen");
                this.showScreen("Poker2LobbyScreen");
                this.onTopScreen("Poker2LobbyTablesScreen");
                this.hideBackgroundLayer();
                /*					if(!Poker2Model.userData.firstLogin)
                                        if( Poker2Model.sessionData.activeSpecialOffer && (_currentState == STATE_LOGIN || _currentState == STATE_CONNECT))
                                        {
                                            Poker2Model.sessionData.initSessionTime( Poker2Model.sessionData.OFFER_INTERVAL, Poker2Model.sessionData.SPECIALOFFER_TIMER );
                                            layoutManager.showDialog( "PokerPaymentTeaserDialog" );
                                        }*/
                break;
            case 18:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2FriendsPanel");
                this.showScreen("Poker2BackgroundScreen");
                this.showScreen("Poker2RankingScreen");
                this.showScreen("Poker2LobbyScreen");
                this.onTopScreen("Poker2RankingScreen");
                break;
            case 19:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2FriendsPanel");
                this.showScreen("Poker2BackgroundScreen");
                this.showScreen("Poker2AchivementStatsScreen");
                this.showScreen("Poker2LobbyScreen");
                this.onTopScreen("Poker2AchivementStatsScreen");
                break;
            case 20:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2FriendsPanel");
                this.showScreen("Poker2BackgroundScreen");
                this.showScreen("Poker2BoosterScreen");
                this.showScreen("Poker2LobbyScreen");
                this.onTopScreen("Poker2BoosterScreen");
                break;
            case 10:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2TableActionPanel");
                this.showScreen("Poker2OnTableScreen");
                break;
            case 16:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showScreen("Poker2BackgroundScreen");
                this.showPanel("Poker2TableActionPanel");
                break;
            case 13:
            case 12:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2FriendsPanel");
                this.showScreen("Poker2ShopScreen");
                this.showScreen("Poker2LobbyScreen");
                this.onTopScreen("Poker2ShopScreen");
                BasicDialogHandler.getInstance().blockDialogs = false;
                break;
            case 14:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2FriendsPanel");
                this.showScreen("Poker2TournamentScreen");
                this.showScreen("Poker2LobbyScreen");
                this.onTopScreen("Poker2TournamentScreen");
                break;
            case 15:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2FriendsPanel");
                this.showScreen("Poker2TourTablesScreen");
                this.showScreen("Poker2LobbyScreen");
                this.onTopScreen("Poker2TourTablesScreen");
                break;
            case 17:
                this.hideAllPanels();
                this.hideAllMetaPanels();
                this.hideAllDialogs();
                this.hideAllScreens();
                this.backgroundLayer.visible = false;
                this.showPanel("Poker2MenuPanel");
                this.showPanel("Poker2FriendsPanel");
                this.showScreen("Poker2SitnGoScreen");
                this.showScreen("Poker2LobbyScreen");
                this.onTopScreen("Poker2SitnGoScreen");
                break;
        }

        if (this._currentState != stateId) {
            var preOutGameState: boolean = !!(this.outGameState);
            this.previousState = int(this._currentState);
            this._currentState = stateId;

            if (preOutGameState && this.inGameState)
                Poker2Model.sessionData.executeInGameCommands();
            BasicController.getInstance().dispatchEvent(new Poker2DialogEvent("changelayoutstate", [this._currentState, this._previousState]));
        }

        // add the cheats panel
        if(this._currentState >= 10 && (this.env.isLocal || this.env.isTest || this.env.isDevTest)){
            this.showPanel(Poker2CheatsPanel.NAME);
        }
        else{
            this.hidePanel(Poker2CheatsPanel.NAME);
        }
    }

    /**
     *	erzeugt TutorialPfeil
     */
    public addTutorialArrow(arrow: MovieClip): void {
        this.tutorialLayer.addChild(arrow);
        arrow.scaleX = (arrow.scaleX * this.scaleFactor);
        arrow.scaleY = (arrow.scaleY * this.scaleFactor);
    }

    /**
     *	erzeugt TutorialPanel
     */
    public addTutorialPanel(): void {
        this.tutPanel = new Poker2TutorialPanel(new Library.PokerTutorial.TutorialPanel());
        this.tutorialLayer.addChild(this.tutPanel.disp);
        this.tutorialLayer.visible = true;
    }

    /**
     *	löscht TutorialPanel
     */
    public removeTutorialPanel(): void {
        if (this.tutPanel) {
            this.tutorialLayer.removeChild(this.tutPanel.disp);
            this.tutPanel.destroy();
            this.tutPanel = null;
            this.tutorialStage.update();
        }
    }

    // TODO: complete implementation
    public showMetaPanel(target: DisplayObject, properties: BasicDialogProperties = null): void {
        let panel = this.metaPanels.get("Poker2LanguageSelectionMetaPanel");
        if (panel) {
            panel.show();
        } else {
            var metaPanel: Poker2Panel;
            // TODO: implement metaPanel factory
            // metaPanel = createFlashComponent(metaPanelId) as BasicPanel;
            metaPanel = new Poker2LanguageSelectionMetaPanel(target) as Poker2Panel;

            this._metaPanelLayer.addChild(metaPanel.disp);

            this.metaPanels.set("Poker2LanguageSelectionMetaPanel", metaPanel);
            metaPanel.show();
        }
    }

    private hideAllMetaPanels(): void {
        if (this.metaPanels != null) {
            for (let entryList of Array.from(this.metaPanels.values())) {
                var metaPanel: any = entryList;
                if (metaPanel === undefined) { continue; }

                metaPanel.hide();
            }
        }
    }

    /**
     * destroy all panels from panellayer
     */
    public clearAllMetaPanels(): void {
        if (this.metaPanels != null) {
            for (let entryList of Array.from(this.metaPanels.values())) {
                var panel: any = entryList;
                if (panel === undefined) { continue; }

                panel.hide();
                panel.destroy();
                this._metaPanelLayer.removeChild(panel.disp);
            }
        }
        this.metaPanels = new Map<any, any>();
    }

    public hideAllScreens(): void {
        if (this.screens != null) {
            this.screens.forEach(screen => {
                if (screen.isVisible() && !(instanceOfClass(screen, "Poker2BackgroundScreen"))) {
                    screen.hide();
                }
            });
        }
    }

    public toggleFullscreen(): void {
        if (this.isDocumentHidden()) {
            return;
        }
        const isActuallyInFullscreen = !!(document as any).fullscreenElement || !!(document as any).webkitFullscreenElement || !!(document as any).mozFullScreenElement || !!(document as any).msFullscreenElement;
        if (this.stage.displayState == StageDisplayState.FULL_SCREEN && isActuallyInFullscreen) {
            this.revertFullscreen();
        } else {
            try {
                this.stage.displayState = StageDisplayState.FULL_SCREEN;
                let element = document.documentElement as any;
                if (element.requestFullscreen) {
                    element.requestFullscreen().catch((e) => {});
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.webkitRequestFullscreen) {
                    element.webkitRequestFullscreen();
                }
                BasicController.getInstance().dispatchEvent(new Poker2DialogEvent("onchangefullscreen"));
            } catch (error) {
                // warn("ERROR: Could not switch to FULL_SCREEN:", error);
            }
        }
    }

    public revertFullscreen(): void {
        if (this.isDocumentHidden() || !document.hasFocus()) {
            return;
        }
        const isActuallyInFullscreen = !!(document as any).fullscreenElement || !!(document as any).webkitFullscreenElement || !!(document as any).mozFullScreenElement || !!(document as any).msFullscreenElement;
        if(!isActuallyInFullscreen) return;
        var oldDisplayState: string = this.stage.displayState;

        super.revertFullscreen();
        this.stage.displayState = StageDisplayState.NORMAL;
        if (this.stage.displayState != oldDisplayState) {
            BasicController.getInstance().dispatchEvent(new Poker2DialogEvent("onchangefullscreen"));
        }
    }

    public get isActiveFullscreen(): boolean {
        return this.stage.displayState == StageDisplayState.FULL_SCREEN;
    }

    public showAnimation(animation: DisplayObject): void {
        this._animationLayer.addChild(animation);
    }

    public hideAnimation(animation: MovieClip): void {
        if (animation.parent == this._animationLayer)
            this._animationLayer.removeChild(animation);
    }

    public clearAllLayoutContent(): void {
        super.clearAllLayoutContent();
        this.removeTutorialPanel();
        this.clearAllMetaPanels();
        this.clearToolTipLayer();
        this.tooltipManager = new Poker2ToolTipManager(this.tooltipLayer);
    }

    // TODO: refactor this! Maybe the login process should use independent commands
    public clearLayoutContentExceptDialogs(): void {
        this.clearAllPanels();
        this.clearAllScreens();
        this.clearAllMetaPanels();
        this.clearToolTipLayer();

        this.tooltipManager = new Poker2ToolTipManager(this.tooltipLayer);
    }

    private clearToolTipLayer(): void {
        this.tooltipManager.destroy();

        while (this.tooltipLayer.numChildren > 0)
            this.tooltipLayer.removeChildAt(0);
    }

    /**
     * Poker didn't register textfield as GoodgameTextfield, so GoodgameTextFieldManager.getInstance().updateTextInAllTextFields()
     * is not working, but we have some `onFontsLoaded` functions which changes the text, we need to invoke them for textfield update
     */
    public onLanguageChangedAndFontReady() {
        Array.from(this.dialogs.values()).forEach(dialog => {
            if ((dialog as any).onFontsLoaded) {
                (dialog as any).onFontsLoaded();
            }
        });
        Array.from(this.panels.values()).forEach(panel => {
            if ((panel as any).onFontsLoaded) {
                (panel as any).onFontsLoaded();
            }
        });
    }

    /*		public function setProgressbar():void
            {
                onStartProgressbar();
    //			_backgroundComponent.updateProgressText = Poker2Model.languageData.getTextById( "progress_serverconnection" );
                _backgroundComponent.updateLoadingProgress( 99 );
            }*/

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }

    protected createFlashComponent(componentId: string): FlashUIComponent {
        switch (componentId) {
            // Panels
            case "Poker2MenuPanel":
                return new Poker2MenuPanel(new Library.PokerMenuPanel.MenuPanel());
            case "Poker2LoginPanel":
                return new Poker2LoginPanel(new Library.PokerInterface.PokerLogin());
            case "Poker2FriendsPanel":
                return new Poker2FriendsPanel(new Library.PokerFriendsPanel.FriendsPanel());
            case "Poker2TableActionPanel":
                return new Poker2TableActionPanel(new Library.PokerTableActionPanel.TableActionPanel());

            // Screens
            case "Poker2LobbyTablesScreen":
                return new Poker2LobbyTablesScreen(new Library.PokerInterface.PokerLobbyTables());
            case "Poker2BackgroundScreen":
                if (this.backgroundScreen == null) {
                    this.backgroundScreen = new Poker2BackgroundScreen(new Container());
                }
                return this.backgroundScreen;
            case "Poker2LobbyScreen":
                return new Poker2LobbyScreen(new Library.PokerInterface.PokerLobby());
            case "Poker2ShopScreen":
                return new Poker2ShopScreen(new Library.PokerInterface.PokerShop());
            case "Poker2OnTableScreen":
                return new Poker2OnTableScreen(new Library.PokerTable.PokerOnTable());
            case "Poker2TournamentScreen":
                return new Poker2TournamentScreen(new Library.PokerInterface.PokerTournamentLobby());
            case "Poker2TourTablesScreen":
                return new Poker2TourTablesScreen(new Library.PokerInterface.PokerTournamentTables());
            case "Poker2SitnGoScreen":
                return new Poker2SitnGoScreen(new Library.PokerInterface.PokerSitnGoLobby());
            case "Poker2RankingScreen":
                return new Poker2RankingScreen(new Library.PokerInterface.PokerRanking());
            case "Poker2AchivementStatsScreen":
                return new Poker2AchivementStatsScreen(new Library.PokerInterface.PokerProfil());
            case "Poker2BoosterScreen":
                return new Poker2BoosterScreen(new Library.PokerInterface.PokerBooster());

            // Dialogs
            case "Poker2WarningDialog":
                return new Poker2WarningDialog(new Library.PokerInterface.PokerStandardOk());
            case Poker2StandardOkDialog.NAME:
                return new Poker2StandardOkDialog(new Library.PokerInterface.PokerStandardOk());
            case Poker2StandardYesNoDialog.NAME:
                return new Poker2StandardYesNoDialog(new Library.PokerInterface.PokerStandardYesNo());
            case "Poker2WorldSelectionDialog":
                return new Poker2WorldSelectionDialog(new Library.PokerInterface.PokerWorldSelection());
            case Poker2RegisterDialog.NAME:
                return new Poker2RegisterDialog(new Library.PokerInterface.PokerRegister());
            case "Poker2RegisterSocialDialog":
                return new Poker2RegisterSocialDialog(new Library.PokerInterface.PokerRegisterSocial());
            case "Poker2LostPasswordDialog":
                return new Poker2LostPasswordDialog(new Library.PokerInterface.PokerLostPassword());
            case "Poker2NoMoneyDialog":
                return new Poker2NoMoneyDialog(new Library.PokerInterface.PokerNoMoney());
            case Poker2ReconnectDialog.NAME:
                return new Poker2ReconnectDialog(new Library.PokerInterface.PokerStandardOk());
            case "Poker2AvatarCreationDialog":
                return new Poker2AvatarCreationDialog(new Library.PokerInterface.PokerAvatarCreation());
            case Poker2AvatarCreationDialogPreload.NAME:
                return new Poker2AvatarCreationDialogPreload(new Library.PokerInterface.PokerAvatarCreationSocial());
            case "Poker2CreateTableDialog":
                return new Poker2CreateTableDialog(new Library.PokerInterface.PokerCreateTable());
            case "Poker2ProfilDialog":
                return new Poker2ProfilDialog(new Library.PokerInterface.PokerProfil());
            case "Poker2TakeSeatDialog":
                return new Poker2TakeSeatDialog(new Library.PokerInterface.PokerTakeSeat());
            case "Poker2SendGiftDialog":
                return new Poker2SendGiftDialog(new Library.PokerInterface.PokerGiftShop());
            case "Poker2TourInvitationDialog":
                return new Poker2TourInvitationDialog(new Library.PokerInterface.PokerTournmentInvitation());
            case "Poker2TourRegisterDialog":
                return new Poker2TourRegisterDialog(new Library.PokerInterface.PokerTournamentRegister());
            case "Poker2RankingDialog":
                return new Poker2RankingDialog(new Library.PokerInterface.PokerRanking());
            case "Poker2PopUpAchievementDialog":
                return new Poker2PopUpAchievementDialog(new Library.PokerPopUps.Poker2PopUpAchievement());
            case "Poker2RankingAvatarDialog":
                return new Poker2AvatarCardDialog(new Library.PokerInterface.RankingAvatarCard());
            case "Poker2TableAvatarDialog":
                return new Poker2TableAvatarDialog(new Library.PokerInterface.OnTableAvatarCard());
            case "Poker2HelpDialog":
                return new Poker2HelpDialog(new Library.PokerInterface.PokerHelp());
            case "Poker2HelpTournamentDialog":
                return new Poker2HelpTournamentDialog(new Library.PokerInterface.PokerHelp());
            case "Poker2OptionDialog":
                return new Poker2OptionDialog(new Library.PokerInterface.PokerOption());
            case "Poker2TableAchievement":
                return new Poker2TableAchievement(new Library.PokerInterface.OnTableAchievement());
            case "Poker2TourResult1Dialog":
                return new Poker2TourResult1Dialog(new Library.PokerPopUps.PokerTourResult1a());
            case "Poker2TourResult2Dialog":
                return new Poker2TourResult2Dialog(new Library.PokerPopUps.PokerTourResult1b()); // no pokal
            case "Poker2TourResult3Dialog":
                return new Poker2TourResult3Dialog(new Library.PokerPopUps.PokerTourResult2()); // tp
            case "Poker2LoginBonusDialog":
                // Using new daily bonus dialog with a four day cycle
                return new Poker2LoginBonusDialog4Days(new Library.PokerPopUps.PokerDailyLoginBonus_4day_period());
            case "Poker2MailVerificationDialog":
                return new Poker2MailVerificationDialog(new Library.PokerPopUps.Poker2MailVerification());
            case "Poker2MailVerificationGiftDialog":
                return new Poker2MailVerificationGiftDialog(new Library.PokerPopUps.Poker2MailVerificationGift());
            case "Poker2MailConfirmGiftDialog":
                return new Poker2MailConfirmGiftDialog(new Library.PokerPopUps.Poker2MailConfirmGift());
            case "Poker2BoosterBuyDialog":
                return new Poker2BoosterBuyDialog(new Library.PokerInterface.PokerBooster());
            case "Poker2BanditDialog":
                return new Poker2BanditDialog(new Library.PokerBandit.PokerBandit());
            case "Poker2AddFriendDialog":
                return new Poker2AddFriendDialog(new Library.PokerInterface.PokerStandardYesNo());
            case "Poker2InviteFriendDialog":
                return new Poker2InviteFriendDialog(new Library.PokerInterface.PokerInviteFriend());
            case "Poker2TourTableWinDialog":
                return new Poker2TourTableWinDialog(new Library.PokerPopUps.PokerTourTableWin());
            case "Poker2ReportPlayerDialog":
                return new Poker2ReportPlayerDialog(new Library.PokerInterface.PokerReportPlayer());
            case "Poker2RegisterGuestPopUpDialog":
                return new Poker2RegisterGuestPopUpDialog(new Library.PokerInterface.PokerRegisterGuestPopUp());
            case "Poker2GuestInviteFriendDialog":
                return new Poker2GuestInviteFriendDialog(new Library.PokerInterface.PokerGuestInviteFriend());
            case "PokerPaymentTeaserDialog":
                return new Poker2PaymentTeaserDialog(new Library.PokerPopUps.PaymentBonusPopUp());
            case "Poker2FeatureDialog":
                return new Poker2FeatureDialog(new Container());
            case "Poker2BrokeDialog":
                return new Poker2BrokeDialog(new Library.PokerInterface.PokerBroke());
            case "Poker2JoinSitnGoDialog":
                return new Poker2JoinSitnGoDialog(new Library.PokerInterface.PokerStandardYesNo());
            case "Poker2SitnGoResultDialog":
                return new Poker2SitnGoResultDialog(new Library.PokerPopUps.PokerTourResult3());
            case "Poker2RegisterBonusDialog":
                return new Poker2RegisterBonusDialog(new Library.PokerPopUps.RegisterBonusXP());
            case "Poker2GiveChipsConfigDialog":
                return new Poker2GiveChipsConfigDialog(new Library.PokerInterface.PokerGiveChipsConfig());
            case "PokerFeedbackDialog":
                return new Poker2FeedbackDialog(new Library.PokerInterface.PokerFeedback());

            // tutorial
            case "Poker2TutorialNoCancelDialog":
                return new Poker2TutorialNoCancelDialog(new Library.PokerTutorial.PokerTutorialNoCancel());
            case "Poker2TournamentRebuyDialog":
                return new Poker2TournamentRebuyDialog(new Library.PokerInterface.PokerTournamentRebuy());

            // Animationdialog
            case "Poker2LevelUpAnimDialog":
                return new Poker2LevelUpAnimDialog(new Library.PokerPopUps.PokerLevelUp());

            // Fade Dialog
            case "Poker2FadingDialog":
                return new Poker2FadingDialog(new Library.PokerInterface.PokerStandardFade());

            // starter package teaer
            case "Poker2StarterPackageTeaserDialog":
                return new Poker2StarterPackageTeaserDialog(new Library.PokerStarterPackages.PokerStarterPackageTeaser());

            // starter package buy confirmation
            case "Poker2StarterPackageBuyConfirmationDialog":
                return new Poker2StarterPackageBuyConfirmationDialog(new Library.PokerInterface.PokerStarterPackageBought());

            // starter package bought
            case "Poker2StarterPackageBoughtDialog":
                return new Poker2StarterPackageBoughtDialog(new Library.PokerInterface.PokerStarterPackageBought());

             // cheats panel
            case Poker2CheatsPanel.NAME:
                return new Poker2CheatsPanel(new Library.PokerCheatsPanel.PokerCheatsPanel());

        }
        throw new Error("Unknown component: " + componentId);
        return null;
    }

    public get previousState(): number {
        return this._previousState;
    }

    public set previousState(value: number) {
        this._previousState = value;
    }

    public get currentState(): number {
        return this._currentState;
    }

    // TODO: use while changing language
    public lockApp(lock: boolean): void {
        if (lock) {
            //				trace(">> LOCK APP");
            Poker2LayoutManager.getInstance().mouseChildren = false;
        }
        else {
            //				trace(">> UNLOCK APP");
            Poker2LayoutManager.getInstance().mouseChildren = true;
        }
    }

    /**
     * Hides a specific FadingDialog by a given type.
     * @param type String The type of the dialog.
     */
    public fadeOutFadingDialogByType(type: string, duration: number = 1.0): void {
        if (this.dialogs != null) {
            this.dialogs.forEach(dialog => {
                if (instanceOfClass(dialog, "Poker2FadingDialog") && (<Poker2FadingDialog>dialog).fadeProperties.type === type) {
                    (<Poker2FadingDialog>dialog).fadeOut(duration);
                }
            });
        }
    }

    public clearDialogByInstance(dialogInstance: Poker2FadingDialog): void {
        this.clearDialog(dialogInstance);
    }

    public getPanelById(panelId: string): BasicPanel {
        return this.panels.get(panelId);
    }

    public get animationLayer(): Container {
        return this._animationLayer;
    }

    public set animationLayer(value: Container) {
        this._animationLayer = value;
    }

    public get state(): number {
        return this._state;
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set env(value/*:IEnvironmentGlobals*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(BasicLayoutManager.prototype, "env").set.call(this, value);
    }

    public static __initialize_static_members() {
        Poker2LayoutManager.CANVAS_RESIZED_SIGNAL = new NoneValueSignal();
    }
}
classImplementsInterfaces(Poker2LayoutManager, "Container");

import { instanceOfClass } from "@goodgamestudios/createjs-utilities";
import { PokerGame } from "../PokerGame";
import { Poker2PopUpAchievementDialog } from "./dialogs/achievement/Poker2PopUpAchievementDialog";
import { Poker2LevelUpAnimDialog } from "./dialogs/animdialog/Poker2LevelUpAnimDialog";
import { Poker2BanditDialog } from "./dialogs/bandit/Poker2BanditDialog";
import { Poker2BoosterBuyDialog } from "./dialogs/booster/Poker2BoosterBuyDialog";
import { Poker2GiveChipsConfigDialog } from "./dialogs/giveChipsConfig/Poker2GiveChipsConfigDialog";
import { Poker2CreateTableDialog } from "./dialogs/lobby/Poker2CreateTableDialog";
import { Poker2LoginBonusDialog } from "./dialogs/login/Poker2LoginBonusDialog";
import { Poker2LoginBonusDialog4Days } from "./dialogs/login/Poker2LoginBonusDialog4Days";
import { Poker2MailConfirmGiftDialog } from "./dialogs/mailverification/Poker2MailConfirmGiftDialog";
import { Poker2MailVerificationDialog } from "./dialogs/mailverification/Poker2MailVerificationDialog";
import { Poker2MailVerificationGiftDialog } from "./dialogs/mailverification/Poker2MailVerificationGiftDialog";
import { Poker2TableAchievement } from "./dialogs/onTable/Poker2TableAchievement";
import { Poker2TableAvatarDialog } from "./dialogs/onTable/Poker2TableAvatarDialog";
import { Poker2TakeSeatDialog } from "./dialogs/onTable/Poker2TakeSeatDialog";
import { Poker2AddFriendDialog } from "./dialogs/Poker2AddFriendDialog";
import { Poker2BrokeDialog } from "./dialogs/Poker2BrokeDialog";
import { Poker2FadingDialog } from "./dialogs/Poker2FadingDialog";
import { Poker2FeedbackDialog } from "./dialogs/Poker2FeedbackDialog";
import { Poker2GuestInviteFriendDialog } from "./dialogs/Poker2GuestInviteFriendDialog";
import { Poker2HelpDialog } from "./dialogs/Poker2HelpDialog";
import { Poker2HelpTournamentDialog } from "./dialogs/Poker2HelpTournamentDialog";
import { Poker2InviteFriendDialog } from "./dialogs/Poker2InviteFriendDialog";
import { Poker2LostPasswordDialog } from "./dialogs/Poker2LostPasswordDialog";
import { Poker2NoMoneyDialog } from "./dialogs/Poker2NoMoneyDialog";
import { Poker2OptionDialog } from "./dialogs/Poker2OptionDialog";
import { Poker2PaymentTeaserDialog } from "./dialogs/Poker2PaymentTeaserDialog";
import { Poker2ProfilDialog } from "./dialogs/Poker2ProfilDialog";
import { Poker2ReconnectDialog } from "./dialogs/Poker2ReconnectDialog";
import { Poker2ReportPlayerDialog } from "./dialogs/Poker2ReportPlayerDialog";
import { Poker2SendGiftDialog } from "./dialogs/Poker2SendGiftDialog";
import { Poker2StandardOkDialog } from "./dialogs/Poker2StandardOkDialog";
import { Poker2StandardYesNoDialog } from "./dialogs/Poker2StandardYesNoDialog";
import { Poker2TutorialNoCancelDialog } from "./dialogs/Poker2TutorialNoCancelDialog";
import { Poker2WarningDialog } from "./dialogs/Poker2WarningDialog";
import { Poker2WorldSelectionDialog } from "./dialogs/Poker2WorldSelectionDialog";
import { Poker2AvatarCardDialog } from "./dialogs/ranking/Poker2AvatarCardDialog";
import { Poker2RankingDialog } from "./dialogs/ranking/Poker2RankingDialog";
import { Poker2AvatarCreationDialog } from "./dialogs/registration/Poker2AvatarCreationDialog";
import { Poker2RegisterBonusDialog } from "./dialogs/registration/Poker2RegisterBonusDialog";
import { Poker2RegisterDialog } from "./dialogs/registration/Poker2RegisterDialog";
import { Poker2RegisterGuestPopUpDialog } from "./dialogs/registration/Poker2RegisterGuestPopUpDialog";
import { Poker2RegisterSocialDialog } from "./dialogs/registration/Poker2RegisterSocialDialog";
import { Poker2JoinSitnGoDialog } from "./dialogs/sitngo/Poker2JoinSitnGoDialog";
import { Poker2SitnGoResultDialog } from "./dialogs/sitngo/Poker2SitnGoResultDialog";
import { Poker2StarterPackageBoughtDialog } from "./dialogs/starterPackages/Poker2StarterPackageBoughtDialog";
import { Poker2StarterPackageBuyConfirmationDialog } from "./dialogs/starterPackages/Poker2StarterPackageBuyConfirmationDialog";
import { Poker2StarterPackageTeaserDialog } from "./dialogs/starterPackages/Poker2StarterPackageTeaserDialog";
import { Poker2FeatureDialog } from "./dialogs/teaser/Poker2FeatureDialog";
import { Poker2TourInvitationDialog } from "./dialogs/tournament/Poker2TourInvitationDialog";
import { Poker2TournamentRebuyDialog } from "./dialogs/tournament/Poker2TournamentRebuyDialog";
import { Poker2TourRegisterDialog } from "./dialogs/tournament/Poker2TourRegisterDialog";
import { Poker2TourResult1Dialog } from "./dialogs/tournament/Poker2TourResult1Dialog";
import { Poker2TourResult2Dialog } from "./dialogs/tournament/Poker2TourResult2Dialog";
import { Poker2TourResult3Dialog } from "./dialogs/tournament/Poker2TourResult3Dialog";
import { Poker2TourTableWinDialog } from "./dialogs/tournament/Poker2TourTableWinDialog";
import { Poker2FriendsPanel } from "./panels/Poker2FriendsPanel";
import { Poker2LanguageSelectionMetaPanel } from "./panels/Poker2LanguageSelectionMetaPanel";
import { Poker2LoginPanel } from "./panels/Poker2LoginPanel";
import { Poker2MenuPanel } from "./panels/Poker2MenuPanel";
import { Poker2TableActionPanel } from "./panels/Poker2TableActionPanel";
import { Poker2TutorialPanel } from "./panels/Poker2TutorialPanel";
import { Poker2ToolTipManager } from "./Poker2ToolTipManager";
import { Poker2AchivementStatsScreen } from "./screens/Poker2AchivementStatsScreen";
import { Poker2BackgroundScreen } from "./screens/Poker2BackgroundScreen";
import { Poker2BoosterScreen } from "./screens/Poker2BoosterScreen";
import { Poker2LobbyScreen } from "./screens/Poker2LobbyScreen";
import { Poker2LobbyTablesScreen } from "./screens/Poker2LobbyTablesScreen";
import { Poker2OnTableScreen } from "./screens/Poker2OnTableScreen";
import { Poker2RankingScreen } from "./screens/Poker2RankingScreen";
import { Poker2ShopScreen } from "./screens/Poker2ShopScreen";
import { Poker2SitnGoScreen } from "./screens/Poker2SitnGoScreen";
import { Poker2TournamentScreen } from "./screens/Poker2TournamentScreen";
import { Poker2TourTablesScreen } from "./screens/Poker2TourTablesScreen";
import {Poker2CheatsPanel} from "./panels/cheats/Poker2CheatsPanel";
import {Poker2AvatarCreationDialogPreload} from "./dialogs/registration/Poker2AvatarCreationDialogPreload";
Poker2LayoutManager.__initialize_static_members();
